import styled from 'styled-components'
import { typography, TypographyProps, color, ColorProps } from 'styled-system'

const Text = styled.p<TypographyProps & ColorProps>({ margin: 0 }, typography, color)

export default Text
